import { Component, Input, OnInit } from '@angular/core';
import { properties } from '../../../../environments/properties';
import { ParamService } from 'src/app/shared/services/param.service';

@Component({
    selector: 'app-customer-service',
    templateUrl: './customer-service.component.html',
    styleUrls: ['./customer-service.component.scss']
})
export class CustomerServiceComponent implements OnInit {

    @Input() userSubscriptionDetails;
    @Input() userInfo;
    @Input() currentEnvironment;
    properties = properties;
    FRESH_PASS_SUBSCRIBERS_RECEIVE_QUICK_CUSTOMER_SERVICE_FROM_A_DEDICATED_SUPPORT_TEAM = ""

    enableForUPlus: boolean = this.properties.featureFlags.enableForUPlus;
    programDisplayData = this.enableForUPlus ? this.properties.programType.forUPlus : this.properties.programType.freshpass;

    constructor(public paramService: ParamService) {
        let banner = this.paramService.banner;
        if (banner && typeof banner === 'string' && banner.length > 0) {
            banner = banner.charAt(0).toUpperCase() + banner.slice(1);
        }
        this.FRESH_PASS_SUBSCRIBERS_RECEIVE_QUICK_CUSTOMER_SERVICE_FROM_A_DEDICATED_SUPPORT_TEAM = this.programDisplayData?.manage?.FRESH_PASS_SUBSCRIBERS_RECEIVE_QUICK_CUSTOMER_SERVICE_FROM_A_DEDICATED_SUPPORT_TEAM?.replace("{banner}", banner);
    }

    ngOnInit(): void {
    }

}
